import * as React from "react";
import type { SVGProps } from "react";
const SvgShare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 12a1 1 0 1 0-2 0zm-1 8H3zm17-8a1 1 0 1 0-2 0zm-5.707-5.293a1 1 0 1 0 1.414-1.414zM12 2l.707-.707a1 1 0 0 0-1.414 0zM7.293 5.293a1 1 0 0 0 1.414 1.414zM11 15a1 1 0 1 0 2 0zm-8-3v8h2v-8zm0 8a3 3 0 0 0 .879 2.121l1.414-1.414A1 1 0 0 1 5 20zm.879 2.121A3 3 0 0 0 6 23v-2a1 1 0 0 1-.707-.293zM6 23h12v-2H6zm12 0a3 3 0 0 0 2.121-.879l-1.414-1.414A1 1 0 0 1 18 21zm2.121-.879A3 3 0 0 0 21 20h-2a1 1 0 0 1-.293.707zM21 20v-8h-2v8zM16.707 5.293l-4-4-1.414 1.414 4 4zm-5.414-4-4 4 1.414 1.414 4-4zM11 2v13h2V2z"
    />
  </svg>
);
export default SvgShare;
